// extracted by mini-css-extract-plugin
module.exports = {"faq-container":"certification-prep-faq_faq-container__bkmEC","faq-header":"certification-prep-faq_faq-header__axs1F","faq-answer":"certification-prep-faq_faq-answer__EvAi_"};